import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user/user.module';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  providers: [UserService]
})
export class RegisterComponent implements OnInit {
  user: User;
  token;
	identity;
  status: string;
  pass: string;
  loading:boolean = false;

  constructor(private _userService: UserService,private _route: ActivatedRoute, private _router: Router) {
    this.user = new User(1,'','','','','',false);
   }

  ngOnInit(): void {
    this.identity = this._userService.getIdentity();
    if(this.identity != null){
			this._router.navigate(["/"]);
		}
  }

  onSubmit(form){
    //console.log(this.user);
    this.loading = true;
    if(this.user.password == this.user.img){
      this.pass = 'success';
      this._userService.register(this.user).subscribe(
        response => {
          //if(response.status == "success"){
            //vaciar formulario
            this.token = response;
            localStorage.setItem('token', this.token);
            // Objeto usuario identificado
            this._userService.signup(this.user, true).subscribe( response => {
                this.identity = response;
                localStorage.setItem('identity', JSON.stringify(this.identity));
                this.user = new User(1,'','','','','',false);
                form.reset();
                // Redirección
                this._router.navigate(['home']);
              },
              error => {
                console.log(<any>error);
                this.loading = false;
              }
            );
          // } else {
          //   this.status = "error";
          //   this.loading = false;
          // }
        }, error => {
          console.log(<any>error);
          this.loading = false;
        }
      );


    } else {
     this.pass = 'error';
     this.loading = false;
    }
  }

  
}
